import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import { bem } from 'helpers/class-name';
import DatadogRum, { DATADOG_RUM_ACTIONS } from 'helpers/datadog-rum';
import { trackCrashedPageViewed } from 'helpers/events';
import { getFailedRequests, getLastFailedRequest } from 'helpers/http';
import { getDecagonChatPath } from 'helpers/link-generation';
import Message from 'components/Message';
import { selectActiveVenueId } from 'selectors/general';

import messages from './InternalError.messages';
import './InternalError.scss';

const { block, element } = bem('internal-error');

const InternalError = ({ errorCode: errorCodeProp }) => {
  const { pathname, search } = useLocation();
  const venueId = useSelector(selectActiveVenueId);

  useEffect(() => {
    const allFailedRequests = getFailedRequests();
    const lastFailed = getLastFailedRequest();
    const errorCode = errorCodeProp ?? lastFailed?.statusCode;

    trackCrashedPageViewed({ venueId, errorCode });
    DatadogRum.addAction(DATADOG_RUM_ACTIONS.CRASHED_PAGE_VIEWED, {
      urlPath: pathname,
      failedRequestCount: allFailedRequests.length,
      failedEndpoints: allFailedRequests.map(r => r.apiEndpoint).join(', '),
      failedStatusCodes: allFailedRequests.map(r => r.statusCode).join(', '),
      apiEndpoint: lastFailed?.apiEndpoint,
      statusCode: lastFailed?.statusCode,
      method: lastFailed?.method,
    });
  }, [errorCodeProp, pathname, venueId]);

  return (
    <div className={block()}>
      <div className={element('content')}>
        <Message as="p" className="text--bold" message={messages.title} />

        <Message
          as="p"
          message={messages.body}
          values={{
            a: text => <Link to={getDecagonChatPath(pathname, search)}>{text}</Link>,
          }}
        />
      </div>
    </div>
  );
};

InternalError.propTypes = {
  errorCode: PropTypes.number,
};

export default InternalError;
